export const getPLPPrice = (commerceMarket, modelTypeId, plpPrices) => {
  if (
    plpPrices &&
    plpPrices[commerceMarket] &&
    plpPrices[commerceMarket][modelTypeId]
  ) {
    return plpPrices[commerceMarket][modelTypeId];
  }
};